import { useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';
import { useParams } from 'react-router-dom';
import { useFinanceFormInput } from '../../../gqlCommon/hooks/useFinanceFormInput';
import useGetPostCode from '../../../gqlCommon/hooks/useGetPostCode';
import useInsuranceFormInput from '../../../gqlCommon/hooks/useInsuranceFormInput';
import useTrimLabel from './useTrimLabel';
import usePostcodeContext from '../../../gqlCommon/hooks/usePostcodeContext';
import simpleSpecPackTrimLevel from '../../graphql/queries/simpleSpecPackTrimLevel';
import {
  GetSimpleSpecPackTrimLevel,
  GetSimpleSpecPackTrimLevelVariables,
} from '../../graphql/queries/__generated__/GetSimpleSpecPackTrimLevel';
import usePostcodeErrorHandler from '../../../gqlCommon/hooks/usePostcodeErrorHandler';
import useErrorHandler from '../../../gqlCommon/hooks/useErrorHandler';
import IParams from '../../../gqlCustomise/model/IParams';
import usePlatformConfig from '../../../common/react/usePlatformConfig';

const useSimpleSpecPackTrimLevel = () => {
  const { trimCode } = useParams<IParams>();
  const filters = {
    trimCode: decodeURIComponent(trimCode),
  };
  const { togglePostcodeLoading } = usePostcodeContext();
  const { financeInput } = useFinanceFormInput();
  const postCode = useGetPostCode();
  const {
    platformConfig: { dataLayer },
  } = usePlatformConfig();
  const [trimPack, setTrimPack] = useState<GetSimpleSpecPackTrimLevel>(null);
  const { insuranceFormData } = useInsuranceFormInput('', true);
  const [errorState, setErrorState] = useState(null);
  const { data, loading, error } = useQuery<GetSimpleSpecPackTrimLevel, GetSimpleSpecPackTrimLevelVariables>(
    simpleSpecPackTrimLevel.GET_SIMPLE_SPEC_PACK_TRIM_LEVEL,
    {
      variables: {
        filters,
        financeInput,
        financeProductId: financeInput?.financeProductId,
        postCode,
        insuranceFormInput: insuranceFormData ? insuranceFormData : null,
        dataLayer: !!dataLayer,
      },
      fetchPolicy: 'cache-and-network',
    },
  );

  const { trimLabelData } = useTrimLabel();

  useEffect(() => {
    if (!loading) {
      setTrimPack(data);
      togglePostcodeLoading(false);
    }
  }, [data, loading]);

  usePostcodeErrorHandler(error, loading, setErrorState);
  useErrorHandler(errorState);

  return {
    data: trimPack,
    loading,
    error: errorState,
    trimLabelData,
  };
};

export default useSimpleSpecPackTrimLevel;
